import type { PageContentType } from '~/helpers/datalayer/types'

/**
 * The current page's classification, read by the content view event and by every Braze custom event.
 *
 * Scoped to the path it was declared on: a page that declares nothing reports `unknown` rather than
 * inheriting the previous page's type.
 */
export function usePageContentType() {
  const declared = useState<{ path: string; type: PageContentType } | undefined>('page-content-type', () => undefined)
  const route = useRoute()

  return {
    contentType: computed<PageContentType>(() =>
      declared.value?.path === route.path ? declared.value.type : 'unknown',
    ),
    setContentType: (type: PageContentType) => (declared.value = { path: route.path, type }),
  }
}
